var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Text } from 'shared/components/ui';
import { useState, useMemo } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { HighlightedString, PersonSearch, } from 'shared/components/features/PersonSearch';
import { useNavigate } from 'react-router-dom';
import { useUsersForSearch } from '../hooks/useUsers';
var personFilter = function (inputValue) {
    return function itemFilter(person) {
        var user = person;
        var rolesInclude = false;
        if (user.care_provider && user.care_provider.roles) {
            user.care_provider.roles
                .map(function (role) { return role.toLowerCase(); })
                .forEach(function (role) {
                if (inputValue && role.includes(inputValue)) {
                    rolesInclude = true;
                }
            });
        }
        return (!inputValue ||
            user.name.toLowerCase().includes(inputValue.toLowerCase()) ||
            (user.care_provider &&
                user.care_provider.states &&
                user.care_provider.states
                    .map(function (state) { return state.toLowerCase(); })
                    .includes(inputValue.toLowerCase())) ||
            user.email.toLowerCase().includes(inputValue.toLowerCase()) ||
            rolesInclude);
    };
};
var getId = function (person) {
    return person.id;
};
var getTitle = function (person, getInputProps) {
    var _a;
    var user = person;
    return (_jsx(Text, __assign({ fontSize: "16px" }, { children: _jsx(HighlightedString, { text: user.name, inputString: (_a = getInputProps().value) === null || _a === void 0 ? void 0 : _a.toString() }) })));
};
var getTitleString = function (person) {
    var user = person;
    return user.name;
};
var getSubtitle = function (person, getInputProps) {
    var _a, _b, _c;
    var user = person;
    var roles = (_a = (user.care_provider && user.care_provider.roles)) !== null && _a !== void 0 ? _a : [];
    var states = (_b = (user.care_provider && user.care_provider.states)) !== null && _b !== void 0 ? _b : [];
    var text = '';
    if (roles.length && states.length) {
        text = roles.join(' ') + ' - ' + states.join(' ');
    }
    else if (roles.length) {
        text = roles.join(' ');
    }
    else if (states.length) {
        text = states.join(' ');
    }
    return (_jsx(Text, __assign({ fontSize: "14px" }, { children: _jsx(HighlightedString, { text: text, inputString: (_c = getInputProps().value) === null || _c === void 0 ? void 0 : _c.toString(), fontSize: "14px" }) })));
};
export var UsersSearchBox = function (props) {
    var onUserSelect = props.onUserSelect, placeholder = props.placeholder, roles = props.roles, userFilter = props.userFilter, inHouseFilter = props.inHouseFilter;
    var methods = useForm();
    var _a = useState(''), terms = _a[0], setTerms = _a[1];
    var navigate = useNavigate();
    var _b = useUsersForSearch(terms, { roles: roles, inHouseFilter: inHouseFilter }), unfilteredUsers = _b.data, usersLoading = _b.isLoading, userLoadingIsError = _b.isError;
    var users = useMemo(function () {
        if (unfilteredUsers && userFilter) {
            return unfilteredUsers.filter(userFilter);
        }
        return unfilteredUsers;
    }, [unfilteredUsers, userFilter]);
    var selectUser = function (newPerson) {
        var newUser = newPerson;
        if (onUserSelect) {
            onUserSelect(newUser);
        }
        else {
            navigate(newUser.id);
        }
    };
    return (_jsx(FormProvider, __assign({}, methods, { children: _jsx("form", __assign({ onSubmit: function (e) {
                if (e.cancelable) {
                    e.preventDefault();
                }
            } }, { children: _jsx(PersonSearch, { width: "380px", maxResultsHeight: "253px", persons: users !== null && users !== void 0 ? users : [], terms: terms, onInputChange: setTerms, onSelectChange: selectUser, personFilter: personFilter, getId: getId, getTitle: getTitle, getTitleString: getTitleString, getSubtitle: getSubtitle, resultsBoxShadow: '0px 3px 12px 0px rgba(0, 0, 0, 0.15)', resultsBoxPadding: 4, placeholder: placeholder || 'Search by name', "data-testid": "searchByName", emptyStateText: "No user found. Please try a different search term.", paddingBottom: 2, paddingLeft: 0, marginLeft: 0, isLoading: usersLoading, isError: userLoadingIsError }) })) })));
};
